var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoreeClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25105 6.25105C6.58579 5.91632 7.1285 5.91632 7.46323 6.25105L12 10.7878L16.5368 6.25105C16.8715 5.91632 17.4142 5.91632 17.7489 6.25105C18.0837 6.58579 18.0837 7.1285 17.7489 7.46323L13.2122 12L17.7489 16.5368C18.0837 16.8715 18.0837 17.4142 17.7489 17.7489C17.4142 18.0837 16.8715 18.0837 16.5368 17.7489L12 13.2122L7.46323 17.7489C7.1285 18.0837 6.58579 18.0837 6.25105 17.7489C5.91632 17.4142 5.91632 16.8715 6.25105 16.5368L10.7878 12L6.25105 7.46323C5.91632 7.1285 5.91632 6.58579 6.25105 6.25105Z",
    fill: "#585858"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoreeClose);
export default __webpack_public_path__ + "static/media/loree-close.23bfb562e281f7dc278d038d0c92b0b7.svg";
export { ForwardRef as ReactComponent };